export default {
  common: {
    selAll: 'Select all',
    navTab: 'Nav Tab',
    contactNumber: 'Contact Number',
    max10: 'Up to 10',
    oFrequency1: 'Only the first visit appears',
    oFrequency2: 'No repeat appearance within 3 days of visit',
    oFrequency3: 'do not repeat within 7 days of visit',
    oFrequency4: ' do not repeat within 30 days of visit',
    oFrequency: 'Occurrence frequency',
    question: 'Question',
    welcome: 'greeting',
    style: 'style',
    one: 'one',
    two: 'two',
    three: 'three',
    four: 'four',
    avatar: 'Avatar',
    qrCode: `Weixin Code`,
    infoPosition: 'Information location',
    infoDatas: 'Display information',
    datas: 'datas',
    ratio: 'ratio',
    format: 'format',
    cols: 'Column',
    gap: 'Gap',
    news: 'News',
    business: 'Business',
    cases: 'Case',
    graphic_carouse: 'Graphic carousel',
    requiredItem: 'Required fields',
    contactInfo: 'Contact information',
    width: 'Width',
    height: 'Height',
    noData: 'No Data',
    h5URL: 'URL OF H5',
    mpH5URLTip: 'The service domain name needs to be configured on the wechat public platform',
    toTutorial: 'View the tutorial',
    switchLanguage: 'Switch Language Success',
    companyName: 'Jiatui technology',
    sysVersion: 'Baseline version',
    submit: 'Submit',
    confirm: 'Confirm',
    batch: 'Batch',
    import: 'import',
    cancel: 'Cancel',
    click: 'click to',
    edit: 'Edit',
    delete: 'Delete',
    details: 'Details',
    goBack: 'Go back',
    goTop: 'Go top',
    setting: 'Setting',
    refreshPage: 'Refresh Page',
    close: 'Close',
    closeCurrent: 'Close Current',
    closeLeft: 'Close Left',
    closeRight: 'Close Right',
    closeOthers: 'Close Others',
    closeAll: 'Close All',
    officialAccount: 'OfficialAccount',
    clue: 'Clue',
    customer: 'Customer',
    source: 'Source',
    sourceOfClues: 'Source Of Clues',
    none: 'None',
    name: 'Name',
    anonymousFiles: 'Anonymous Files',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    department: 'Department',
    times: 'Times',
    add: 'Add',
    state: 'State',
    available: 'Available',
    notAvailable: 'Not Available',
    desc: 'Desc',
    events: 'Events',
    tag: 'Tag',
    sticky: 'Sticky',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    operate: 'Operate',
    yes: 'Yes',
    no: 'No',
    QRCode: 'QR Code',
    select: 'Select',
    rightClickToDownload: 'Right click to download',
    default: 'Default',
    miniApp: 'Wechat Mini App',
    browser: 'Browser',
    all: 'All',
    doc: 'Doc',
    image: 'Image',
    type: 'Type',
    view: 'View',
    size: 'Size',
    permisson: 'Permisson',
    move: 'Move',
    staff: 'Staff',
    phone: 'Phone',
    position: 'Position',
    pleaseInput: 'Please Input',
    pleaseSelect: 'Please Select',
    new: 'New',
    to: 'To',
    upload: 'Upload',
    repeat: 'Repeat',
    uploading: 'Uploading',
    success: 'Success',
    enable: 'Enable',
    disable: 'Disable',
    onShelf: 'On Shelf',
    downShelf: 'Down Shelf',
    enterByOneself: 'Enter by Oneself',
    link: 'Link',
    shareLink: 'Share link',
    scanQRcode: 'Scan QR Code',
    manualEntry: 'Manual Entry',
    card: 'Card',
    website: 'Website',
    category: 'Category',
    wordSpacing: ' ',
    export: 'Export',
    belong: 'Belong',
    sales: 'Sales',
    entryMethod: 'Entry method',
    beginTime: 'Begin Time',
    endTime: 'End Time',
    company: 'Company',
    remark: 'Remark',
    customize: 'Customize',
    system: 'System',
    sort: 'Sort',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    group: 'Group',
    leaveUserInfo: 'Leave user info',
    published: 'Published',
    draft: 'Draft',
    notice: 'Notice',
    title: 'Title',
    send: 'Send',
    sended: 'Sended',
    unsent: 'UnSent',
    content: 'Content',
    receive: 'Receive',
    sendImmediately: 'Send immediately',
    sendOnTime: 'Send on time',
    sendTime: 'Send time',
    sendUsersCnt: 'Send users count',
    sendUsers: 'Send users',
    readUsers: 'Read users',
    role: 'Role',
    child: 'Child',
    parent: 'Parent',
    contain: 'Contain',
    icon: 'Icon',
    carousel: 'Carousel',
    carouselImage: 'Carousel image',
    preview: 'Preview',
    backgroundImage: 'Background image',
    page: 'page',
    languageType: 'Language type',
    baseInfo: 'Base info',
    email: 'Email',
    sex: 'Sex',
    notSet: 'Not set',
    male: 'Male',
    famale: 'Famale',
    jobNo: 'Job no',
    address: 'Address',
    is: 'Is',
    thumbnail: 'Thumbnail',
    search: 'Search',
    text: 'Text',
    zhCN: 'zh-CN',
    en: 'en',
    number: 'Number',
    top: 'Top',
    shareCount: 'Share Count',
    pvCount: 'PV Count',
    uvCount: 'UV Count',
    shareType: 'Share Type',
    shareUser: 'Share User',
    publishTime: 'Publish time',
    shareRecord: 'Share record',
    anonymousUser: 'Anonymous user',
    salesDepartment: 'Sales department'
  },
  card: {
    email: 'email',
    visit: 'visit',
    wechat: 'wechat',
    phone: 'phone',
    share: 'Share Card',
    addContact: 'Save Contact',
    tiled: 'Tiled',
    suspensionStrip: 'Suspension strip',
    tempTip: 'Employees can replace business card templates in the mini Program - Personal Center',
    nav: 'Navigation'
  },
  error: {
    returnToHome: 'Back Home'
  },
  tips: {
    qrCodeTip: `Long press to view`,
    shareSettsTip: `This is only valid for customers who do not have a mobile number`,
    shareSettsTip2: `No sales modifications allowed`,
    shareSettsTip3: `Customer's name, mobile phone and company are required for full browsing`,
    shareSettsTip4: `Customers can browse directly in full`,
    isAutoShowTip: 'When the user is not authorized, the leave information box is displayed',
    hideNavTip:
      'You have turned off all navigation and the navigation bar will not be displayed in the applet.',
    importFileName: 'Fail Datas',
    deleteTips: 'Are you sure you want to delete the current item?',
    maxTagTips: 'Select up to 3 tags',
    tagNameLengthTips: 'Tag name cannot exceed 6 characters',
    fileNameLengthTips: 'The file name cannot exceed 30 characters',
    uploadImageTypeTips:
      'Uploaded files can only be in png, jpg, jpeg, bmp, mp4, ppt, pptx, pdf formats',
    uploadFileSizeTips: 'Uploaded files cannot exceed 100MB',
    updateFileTypeTips:
      'When modifying the file content, only files of the same format as the original file type can be re-uploaded',
    fileOperateGiveUpTips:
      'Exiting will cause the uploaded files to become invalid. Do you confirm to exit?',
    saveFailTips: 'Save failed, please save again',
    fileNameEmptyTips: 'Please enter file name',
    cannotBeSpaces: 'Cannot be spaces',
    cannotBeEmpty: 'Cannot be empty',
    timeRangeErrorTips: 'The end time cannot be less than the start time',
    cannotExceed8Characters: 'Cannot exceed 8 characters',
    cannotExceed30Characters: 'Cannot exceed 30 characters',
    cannotExceed40Characters: 'Cannot exceed 40 characters',
    cannotExceed200Characters: 'Cannot exceed 200 characters',
    cannotExceed100Characters: 'Cannot exceed 100 characters',
    tagDeleteTips:
      'This tag group contains sub-tags and cannot be deleted (please clean up the sub-tags before deleting)',
    miniUserVisitTips:
      'Mini Program users need to submit the following information to fully browse',
    productCarouselImageTip:
      'A maximum of 5 files can be uploaded in png/jpg/jpeg format. After the size is changed, upload the wheel cast chart again. Otherwise, the wheel cast chart may be displayed abnormally',
    productCarouselEmptyTip: 'No rotation map was uploaded',
    selectStaffTips: 'Please select staff',
    serverErrorTips: 'Server-side Error',
    miniCustomizeDownShelfTips:
      'Are you sure you want to remove it? Please release a new business card decoration as soon as possible after removing it.',
    websiteDownShelfTips:
      'Are you sure you want to remove it? Please release a new website decoration as soon as possible after removing it.',
    updateImageTips: 'Click on the image to change',
    descInputTips: 'Optional, limited to 200 characters',
    productDescInputTips: 'Optional, limited to 500 characters',
    uploadNineImageTips:
      '9 images have been uploaded (maximum 9 images can be uploaded), and no more images can be uploaded',
    uploadImageTips:
      'Uploaded files can only be  png or jpg,  It is recommended to upload an image of size 600*900',
    uploadImgTypeTips: 'Uploaded files can only be  png or jpg or jpeg',
    uploadImgRatioTips: 'The aspect ratio is ',
    selectLinkTips: 'Please select the redirect child page',
    uploadVideoTypeTips: 'Uploaded videos must be in mp4 format',
    coverPictureTips:
      'It is recommended to upload an image of size 600*900, which is optional. If not uploaded, the first image in the Mini Program and APP list will be used as the cover image by default.',
    updatePdfPPTTips:
      '1) Supports importing PDF/PPT, after which the system automatically generates manual images; 2) Supports batch import of images',
    updateContentTips: 'Please upload/import brochure content',
    backgroundUploadTips: 'Please upload a background image',
    pleaseUploadTips: 'Please upload',
    backgroundSelectTips: 'Please select a background image',
    brochureUploadFileTypeTips: 'Uploaded files must be in pdf、ppt or image format',
    uploadFileProcessBeginTips: 'Only one file is allowed to be uploaded. You have uploaded ',
    uploadFileProcessEndTips: ' files, the file size is',
    requestFailTips: 'Request fail',
    caseCustomizeTips:
      'The position of the case basic information editing column cannot be modified',
    customizeEmptyTips:
      'The content cannot be empty and the last element cannot be deleted (you can add a new element and then delete it)',
    caseBaseInfoInputTips: 'Please input case basic information',
    caseNameInputTips: 'Please input case name',
    caseDescInputTips: 'Please input case desc',
    caseTypeSelectMoreTips: 'The number of case categories selected cannot exceed 9',
    customizeSaveTips:
      'Content items that contain unentered information may cause display problems. Do you want to [Confirm] to save? Or [Cancel] and re-edit and save',
    cardCustomizeBaseInfoNoRepeatTips: 'The profile section cannot be added repeatedly',
    cardCustomizeBaseInfoMoveTips:
      'The location of the business card basic information editing bar cannot be modified',
    websiteShareImageTips: 'Set the official website sharing thumbnail',
    sendUserEmptyTips: 'The sender cannot be empty',
    roleNoPermissionsTips:
      'This role has no checked menu (no permissions), and cannot be bound to a user',
    setPwdTips:
      'You must enter your login password to set a role. If you cancel the setting, you will not be able to set the role.',
    more1Less40Characters: 'must be between 1 and 40 characters',
    more1Less10Characters: 'must be between 1 and 10 characters',
    must11Characters: 'must be 11 characters',
    closeBeforeSaveRoleTips:
      'closing will cause the set role to not be saved. Do you want to close it?',
    setLeaderTips: 'Department leader (used to receive department summary)',
    setLeaderEmptyTips: 'The managed department is not set',
    videoOneUploadTips: 'Only supports uploading one video',
    componentContentEmptyTips: 'Component content is empty、',
    selectErrorTips: 'The selection is invalid. Please select again',
    clickForDetailsTips: 'Click for details',
    dragFile: 'Drop file here or',
    importTip:
      'Import instructions: The file must be in xls or xlsx format, and the department must be established in the organizational structure before importing.',
    importDocTip:
      'When added, this document will serve as a knowledge base for the AI Assistant.【doc/docx support, up to 10Mb】',
    downloadTemplate: 'Download Template',
    dragTips: 'Drag and drop images to sort',
    aiAssistantTips:
      'You are advised to add 3 to 5 default questions for the best user experience.',
    staffKeysTips: 'Support the setting of fields that employees can modify'
  },
  setting: {
    wxaudit: 'Applet audit status Settings',
    version: 'Audit version number',
    audting: 'Under review',
    projectSetting: 'Project Setting',
    interfaceShow: 'Interface Show',
    themeColor: 'Theme Color',
    darkTheme: 'Dark Theme',
    menuMode: 'Menu Mode',
    breadCrumb: 'Bread Crumb',
    menuUnique: 'Menu Unique',
    navTab: 'NavTab',
    navTabIcon: 'NavTabIcon',
    grayMode: 'Gray Mode',
    animateMode: 'Animate Mode',
    tips: 'Tips',
    searchPanel: 'Search Panel',
    staffKeys: 'Employee field Settings',
    DepartmentalMigration: 'Departmental migration',
    departmentTip:
      'If the original department chooses the parent level, it will migrate all child departments and employees under the department',
    delDepartment: 'Do you want to delete the old department after migration',
    oldDepartment: 'Old department',
    newDepartment: 'New department'
  },
  menus: {
    dashboard: 'Dashboard',
    analysis: 'Analysis',
    workbench: 'Workbench',
    multilevelMenu: 'Multilevel Menu',
    secondMenu: 'Second Menu',
    thirdMenu: 'Third Menu',
    systemManagement: 'System Manage',
    menuManagement: 'Menu Manage',
    roleManagement: 'Role Manage',
    userManagement: 'User Manage',
    externalPage: 'External Page',
    juejinPage: 'Juejin Page(link)',
    elementDocs: 'ElementPlus Docs',
    errorPage: 'Error Page',
    403: '403',
    404: '404',
    500: '500',
    about: 'About Project',
    feature: 'Feature',
    directives: 'Directives',
    watermark: 'Watermark',
    selectIcon: 'SelectIcon',
    material: 'Material',
    product: 'Product',
    materialProduct: 'Products',
    materialProductEdit: 'Products Edit',
    materialFile: 'File',
    materialBrochure: 'Brochure',
    materialBrochureEdit: 'Brochure Edit',
    materialCase: 'Case',
    materialCaseEdit: 'Case Edit',
    materialVideo: 'Video',
    materialVideoEdit: 'Video Edit',
    materialConfigCategory: 'Category',
    customize: 'MiniApp Customize',
    customize_visitConfig: 'Visit Config',
    customizeMiniapp: 'Card Customize',
    customizeMiniappEdit: 'Card Customize Edit',
    customizeWebsiteList: 'Page Customize',
    customizeWebsiteEdit: 'Website Customize edit',
    customizeModule: 'Module Customize',
    customizeNav: 'Nav Customize',
    customizeTheme: 'Theme Customize',
    customer: 'Customer',
    customer_clue: 'Clue',
    customer_customer: 'Customer',
    customer_detail: 'Clue/Customer Detail',
    customer_configFollowStatus: 'ClueLifeCycle',
    customer_customerTag: 'CustomerTag',
    company: 'Company',
    company_staff: 'Staff',
    companyStaffAdd: 'Staff Add',
    companyStaffDetail: 'Staff Detail',
    company_role: 'Role Manage',
    company_menu: 'Menu Manage',
    company_workHandover: 'WorkHandover',
    company_company: 'CompanyInfo',
    announcement: 'Announcement',
    announcement_index: 'Announcement',
    announcementDetail: 'Announcement detail',
    ai: 'AI',
    ai_textToImage: 'Text To Image',
    ai_aiVoice: 'AI Voice',
    aiAssistant: 'AI Assistant',
    dataStatistics: 'Data Statistics',
    materialPoster: 'Poster',
    materialPosterEdit: 'Poster Edit',
    materialArticle: 'Article',
    materialArticleEdit: 'Article Edit',
    materialDynamic: 'Dynamic',
    materialDynamicEdit: 'Dynamic Edit',
    tabKnowledge: 'Knowledge base'
  },
  login: {
    login: 'Sign in',
    loginOut: 'LoginOut',
    register: 'Register',
    remember: 'Remember Password',
    forgetPassword: 'Forget password?',
    changePassword: 'Change Password',
    usernamePlaceholder: 'Please input username',
    passwordPlaceholder: 'Please input password',
    passwordValidCheckMsg:
      'Please enter a password that contains uppercase and lowercase English letters, numbers, and is greater than or equal to 8 characters.',
    loginSuccess: 'Login Success',
    welcomeBack: 'Welcome Back',
    loginOutHint: 'Are you sure you want to log out?',
    accountNoPermissonHint:
      'The current account does not have management role permissions, please contact the administrator',
    pleaseInputOldPassword: 'Please Input Old Password',
    pleaseInputNewPassword: 'Please Input New Password',
    pleaseInputNewPasswordAgain: 'Please Input New Password Again',
    theTwoNewPasswordsYouEnteredDoNotMatch: 'The two new passwords you entered do not match',
    modificationSuccessfulPleaseLoginAgain: 'Modification successful, please log in again',
    selectCompanyTips: 'Select the company you want to log in to'
  },
  analysis: {
    staffBusinessCards: 'Staff Business Cards',
    staffPromotions: 'Staff Promotions',
    numberOfVisitors: 'Number of visitors',
    totalClueCustomers: 'Total clue/customers',
    todayAdd: 'Today Add',
    thisWeekAdd: 'This Week Add',
    contentMostFrequentlyVisitedByCustomers: 'Content most frequently visited by customers',
    numberOfVisits: 'Number of visits',
    staffRanking: 'Staff Ranking',
    clueAdd: 'Clue Add',
    shareTimes: 'Share Times',
    customerVisitRecordDetail: 'Customer visit record',
    customerDataDetail: 'Customer record',
    cardShareRecordDetail: 'Card share record',
    cardShareStatistics: 'Card share statistics'
  },
  material: {
    name: 'Material',
    productName: 'Product Name',
    productPrice: 'Product Price',
    productSecondaries: 'Product Secondaries',
    productThird: 'Three-level classification',
    coverPicture: 'Cover Picture',
    pleaseSetNotAvailableItBeforeDeletingIt: 'Please set not available it before deleting it',
    pleaseSetAvailableItBeforeShowQRCode: 'Please set available it before show QR Code',
    folder: 'Folder',
    rootDirectory: 'Root Directory',
    currentDirectory: 'Current Directory',
    directory: 'Directory',
    isPreview: 'Is Preview',
    visibleType: 'Visible Type',
    rename: 'Rename',
    visibleToEveryone: 'Visible to everyone (including all staffs)',
    visibleToDesignatedStaffs: 'Visible to designated staffs',
    visibleToDesignatedDep: 'Visible to designated departments',
    listPicture: 'List Picture',
    relatedMaterialQuantity: 'Related material quantity',
    deleteCategoryTips: 'Please unbind it from the associated materials before deleting it',
    deleteCategoryTips2: 'This category has two levels and cannot be deleted.',
    associatedFiles: 'Associated files',
    useDefaultBackground: 'Use default background',
    customBackground: 'Custom background',
    importContent: 'Import content',
    continueImporting: 'Continue importing',
    conversionCompleted: 'Conversion completed',
    fixedComponentArea: 'Fixed Component',
    businessComponentArea: 'Business Component',
    basicComponentArea: 'Business Component',
    SpecComponentArea: 'More Component',
    relatedMaterialList: 'Related material list',
    selectMaterial: 'Select material',
    attributesArea: 'Attributes Area',
    selectedList: 'Selected list',
    targetArea: 'Target area',
    selectAttrAreaMaterialTips: 'Please select the material on the right',
    selectAttrAreaImageTips: 'Configure properties on the right',
    selectAttrAreaVideoAndImageTips: 'Please select the video and cover image on the right',
    selectAttrAreaCarouselImageTips: 'Please select the carouse image on the right',
    materialsSection: 'Materials section',
    corporateStyle: 'Corporate style',
    videoSection: 'Video section',
    audio: 'Audio'
  },
  customer: {
    lastVisitTime: 'Last visit time',
    visitType: 'Visit Type',
    followState: 'Follow State',
    becomeCustomerTime: 'Become Customer Time',
    currentFollowState: 'Current Follow State',
    lastFollowTime: 'Last Follow Time',
    followTime: 'Follow Time',
    status: 'Status',
    noMovementAllowed: 'No movement allowed',
    noEditAllowed: 'No edit allowed',
    noDeleteAllowed: 'No delete allowed',
    giveUp: 'Give Up',
    makeADeal: 'Make a deal',
    ordinaryNode: 'Ordinary node',
    visitOverview: 'Visit overview',
    browsingContentStatistics: 'Browsing content statistics',
    mostInterestingContent: 'Most interesting content',
    visitRecord: 'Visit record',
    followRecord: 'Follow record',
    totalVisitDuration: 'Total visit duration(seconds)',
    listpage: 'List Page',
    nextStep: 'Next Step',
    listpageTip: 'This page is for preview only and does not support dynamic interaction.'
  },
  config: {
    searchAccessSettings: 'Search Access Settings',
    searchInDefaultCard:
      'The sales business card displayed when you first enter the mini program through search',
    randomCard: 'Enter a random employee business card',
    fixedCard: 'Enter the business card of the designated employee',
    selectCardTips: 'Please select a default sales card',
    businessEdition: 'Business edition',
    simpleEdition: 'Simple edition',
    minimalistEdition: 'Minimalist edition',
    professionalEdition: 'Professional edition',
    lookingUpEdition: 'Looking Up edition',
    customizeThemeTip:
      'After setting the theme color, the color of the main buttons on the applet will change accordingly.'
  },
  announcement: {
    specifiedPerson: 'Specified person',
    everyone: 'Everyone',
    allSales: 'All sales',
    allReferralOfficers: 'All referral officers',
    referralOfficers: 'Referral officers',
    readTime: 'Read time',
    announcementRecipientList: 'Announcement Recipient List'
  },
  company: {
    valid: 'Valid until',
    aiCardSwitch: 'AI card switch',
    aiVideo: 'AI digital human rendering',
    aiVideoStatusfu1: 'No image photos uploaded',
    aiVideoStatus0: 'AI generating',
    aiVideoStatus1: 'AI generated',
    aiVideoStatus2: 'AI generat fail',
    aiCardUseTips:
      'Please contact the system provider to activate the AI ​​function before you can use it',
    pleaseSetDisableBeforeDelete: 'Please set disable before delete',
    pleaseSetEnableBeforeShowQRCode: 'Please set enable before show QR Code',
    addDepartmentNameErrorTips: 'Department name cannot be empty or contain spaces',
    deleteDepartmentErrorTips:
      'sub-departments, please clean up the sub-departments before deleting',
    numberOfRelatedMenus: 'Number of related menus',
    numberOfRelatedUsers: 'Number of related users',
    superAdminAreNotAllowedToEdit: 'Super admin are not allowed to edit',
    superAdminAreNotAllowedToDelete: 'Super admin are not allowed to delete',
    menu: 'Menu',
    initiateHandover: 'Initiate handover',
    handoverParty: 'Handover party',
    receiver: 'Receiver',
    handoverTips:
      'After the handover, the data of the handing party will be transferred to the receiving party and the data of the handing party will be deleted. Are you sure you want to initiate the handover?',
    pleaseSelectStaff: 'Please select staff',
    handoverRepeatTips: 'The sender and receiver cannot be the same, please reselect',
    handoverFinish: 'Handover finish',
    selectHandoverPartyTips:
      'The handing over party must close the business card before handing it over',
    selectReceiverPartyTips: 'The recipient must open the business card before handing it over',
    companyShortName: 'Company short name',
    companyFullName: 'Company full name',
    companyAddress: 'Company address',
    website: 'Website',
    stockCode: 'StockCode',
    companyLogo: 'Company logo',
    companyShortNameLengthTips: 'Company short name cannot exceed 10 characters',
    companyFullNameLengthTips: 'Company full name cannot exceed 40 characters',
    companyAddressLengthTips: 'Company address cannot exceed 50 characters',
    companyLogoLengthTips: 'Company logo cannot exceed 400 characters',
    roleNameLengthTips: 'Role name cannot exceed 10 characters',
    roleDescLengthTips: 'Role desc cannot exceed 30 characters',
    cardShowingMobileNumber: 'Card showing mobile number',
    userRoleSettings: 'User role settings',
    enterYourLoginPassword: 'Enter your login password',
    superAdminRole: 'Super admin role',
    companyAdminRole: 'Company admin role',
    departmentAdminRole: 'Department admin role',
    externalPhone: 'External phone',
    junior: 'Sub'
  }
};
